/**
 * Where Settings → Pipelines lives. It is a section of the organization's
 * settings, so its address carries the tenant; `/settings/pipelines` is not a
 * route. In its own file so the Tickets pages can link here without pulling in
 * the whole Settings page. Without a tenant there is no such section, so it
 * falls back to Settings.
 */
export function pipelinesSettingsTarget(
  tenantId: string | undefined,
  options: { create?: boolean } = {},
): string {
  if (!tenantId) return '/settings';
  const path = `/settings/tenant/${tenantId}/pipelines`;
  return options.create ? `${path}?create=1` : path;
}
